<template>
    <section>
        <b-button size="sm" variant="primary" @click="onCreateNcm" v-if="inventoryProp != null">
            <span class="fa fa-file mr-1"></span> Create NCM
        </b-button>
        <grid-component
            :gridId="gridId"
            :itemData="ncmReportsByParam"
            :fields="fields"
            :handleRowClick="onRowClick"
            :onDelete="onDelete"
            :styleCustom="'height: 160px'"
        />
        <ncm-form modalId="shared-ncmReport-modal" ref="shared-ncmReport-modal" :ncmProp="selectedReport" :inventoryProp="inventoryProp" @savedNcm="getData" />
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import fields from '@/pages/NonconformanceReport/fields';
import { GRID_ID } from '@/shared/constants';
import NcmForm from '@/pages/NonconformanceReport/components/Form'
export default {
    components: {
        GridComponent,
        NcmForm
    },
    props: {
        purchaseOrderLineId: {
            type: [Number, String],
            default: 0
        },
        rmaLineId: {
            type: [Number, String],
            default: 0
        },
        partId: {
            type: [Number, String],
            default: 0
        },
        inventoryProp: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            fields,
            gridId:GRID_ID.NCM_REPORTS_GRID,
            ncmReportObj: {},
            selectedReport: null
        }
    },
    computed: {
        ...mapGetters('ncmReports', ['ncmReportsByParam']),
    },
    methods: {
        ...mapActions('ncmReports', ['getNcmByPurchaseOrderLine', 'getNcmByRmaLine', 'getNcmByPart', 'deleteNcmReport']),
        onCreateNcm() {
            this.selectedReport = null;
            this.$refs['shared-ncmReport-modal'].show();
        },
        onRowClick({dataItem}) {
            this.selectedReport = dataItem;
            this.$refs['shared-ncmReport-modal'].show();
        },
        async onDelete(report) {
            const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete NCM Report (${report.id}) ${report.partNumber}?`});
            if (deleteConfirmed) {
                await this.deleteNcmReport(report.id)
                this.getData();
            }
        },
        async getData() {
            if (this.purchaseOrderLineId > 0) {
                await this.getNcmByPurchaseOrderLine(this.purchaseOrderLineId);
            } else if (this.rmaLineId > 0) {
                await this.getNcmByRmaLine(this.rmaLineId);
            } else if (this.partId > 0) {
                await this.getNcmByPart(this.partId);
            }
        }
    },
    watch: {
        purchaseOrderLineId() {
            this.getData();
        },
        rmaLineId() {
            this.getData();
        },
        partId() {
            this.getData();
        },
    }
}
</script>

<style>

</style>